import React from 'react';
import Link from 'next/link';
import { ArrowRight, Globe } from 'lucide-react';

import { cn } from '@/lib/utils/cn';

interface WrapButtonProps {
  className?: string;
  children: React.ReactNode;
  href?: string;
}

const WrapButton: React.FC<WrapButtonProps> = ({
  className,
  children,
  href,
}) => {
  return (
    <div className="flex items-center justify-center">
      {href ? (
        <Link href={href}>
          <div
            className={cn(
              'group border-border/50 bg-card/30 hover:border-primary/30 hover:bg-primary/5 flex h-[64px] cursor-pointer items-center gap-2 rounded-full border p-[11px] shadow-lg backdrop-blur-sm transition-all duration-300 hover:scale-[1.02] hover:shadow-xl',
              className,
            )}
          >
            <div className="border-primary/30 bg-primary/20 text-primary-foreground flex h-[43px] items-center justify-center rounded-full border shadow-inner backdrop-blur-sm">
              <p className="mr-3 ml-2 flex items-center justify-center gap-2 font-medium tracking-tight">
                {children}
              </p>
            </div>
            <div className="text-muted-foreground border-border/50 group-hover:border-primary/40 group-hover:bg-primary/10 flex size-[26px] items-center justify-center rounded-full border-2 backdrop-blur-sm transition-all duration-300 ease-in-out group-hover:ml-2">
              <ArrowRight
                size={18}
                className="group-hover:text-primary transition-all duration-300 ease-in-out group-hover:rotate-45"
              />
            </div>
          </div>
        </Link>
      ) : (
        <div
          className={cn(
            'group border-border/50 bg-card/30 hover:border-secondary/30 hover:bg-secondary/5 flex h-[64px] cursor-pointer items-center gap-2 rounded-full border p-[11px] shadow-lg backdrop-blur-sm transition-all duration-300 hover:scale-[1.02] hover:shadow-xl',
            className,
          )}
        >
          <div className="border-secondary/30 bg-secondary/20 text-secondary-foreground flex h-[43px] items-center justify-center rounded-full border shadow-inner backdrop-blur-sm">
            <Globe className="text-secondary mx-2 animate-spin" />
            <p className="mr-3 font-medium tracking-tight">
              {children ? children : 'Get Started'}
            </p>
          </div>
          <div className="text-muted-foreground border-border/50 group-hover:border-secondary/40 group-hover:bg-secondary/10 flex size-[26px] items-center justify-center rounded-full border-2 backdrop-blur-sm transition-all duration-300 ease-in-out group-hover:ml-2">
            <ArrowRight
              size={18}
              className="group-hover:text-secondary transition-all duration-300 ease-in-out group-hover:rotate-45"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default WrapButton;
